import { useTranslation } from 'react-i18next'

import { IconNG } from '../../Icon'
import { TableCellBase, TableCellText } from '../../Table'

import * as styles from './ChatTableRowLastMessageDeleted.module.css'

import DeleteIcon from '../../../icons/delete.svg'

function ChatTableRowLastMessageDeleted({ unread, ...restProps }) {
  const { t } = useTranslation()

  return (
    <TableCellBase {...restProps}>
      <IconNG Icon={DeleteIcon} />
      <TableCellText
        className={styles.messageDeletedText}
        unread={unread}
        value={t('ChatTable.MessageDeletedKey')}
      />
    </TableCellBase>
  )
}

export default ChatTableRowLastMessageDeleted
